import { render, staticRenderFns } from "./IconLanguage.vue?vue&type=template&id=27622c42&"
import script from "./IconLanguage.vue?vue&type=script&lang=ts&"
export * from "./IconLanguage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports